import React from 'react'
import { LucideIcon } from 'lucide-react'

type Variant = 'primary' | 'success' | 'danger' | 'warning' | 'info' | 'secondary'

interface IconBadgeProps {
  icon: LucideIcon
  variant?: Variant
  size?: number
}

const gradients: Record<Variant, string> = {
  primary: 'linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)',
  success: 'linear-gradient(135deg, #00c853 0%, #007c2b 100%)',
  danger: 'linear-gradient(135deg, #f44336 0%, #b71c1c 100%)',
  warning: 'linear-gradient(135deg, #ffb300 0%, #e65100 100%)',
  info: 'linear-gradient(135deg, #29b6f6 0%, #0277bd 100%)',
  secondary: 'linear-gradient(135deg, #78909c 0%, #37474f 100%)',
}

const shadows: Record<Variant, string> = {
  primary: '0 4px 14px rgba(26,115,232,0.40)',
  success: '0 4px 14px rgba(0,200,83,0.40)',
  danger: '0 4px 14px rgba(244,67,54,0.40)',
  warning: '0 4px 14px rgba(255,179,0,0.40)',
  info: '0 4px 14px rgba(41,182,246,0.40)',
  secondary: '0 4px 14px rgba(120,144,156,0.40)',
}

export const IconBadge: React.FC<IconBadgeProps> = ({ icon: Icon, variant = 'primary', size = 20 }) => (
  <div
    style={{
      width: 48,
      height: 48,
      borderRadius: '50%',
      background: gradients[variant],
      boxShadow: shadows[variant],
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    }}
  >
    <Icon size={size} color='#fff' strokeWidth={2} />
  </div>
)

export default IconBadge
